import * as React from 'react';

export interface ShowDataEventsButtonProps {
  handleClick: () => void;
  showDataEvents: boolean;
}
export const ShowDataEventsButton = ({
  handleClick, showDataEvents,
}: ShowDataEventsButtonProps) =>
  (
    <button
      type="button"
      className={showDataEvents ? 'btn-red force-bg' : 'btn-green'}
      style={showDataEvents ? { marginRight: '5px' } : {}}
      onClick={handleClick}
    >
      {showDataEvents ? 'Hide Data Events' : 'Show Data Events'}
    </button>
  );
